import SvgIcon, { SvgIconProps } from "./SvgIcon";

const ColoredBackpackIcon: React.FC<SvgIconProps> = ({ variant, ...props }) => {
  const isOutlined = variant === "outlined";

  return (
    <SvgIcon {...props}>
      <path
        d="M17 22H8V17V15.5C8 14.6716 8.67157 14 9.5 14H15.5C16.3284 14 17 14.6716 17 15.5V17V22Z"
        fill={isOutlined ? "#FFFFFF" : "#D8256D"}
        fillOpacity={isOutlined ? 1 : 0.2}
        stroke="#D8256D"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path d="M8 17H17" fill="none" stroke="#D8256D" strokeWidth="1.5" />

      <path
        d="M16 5.05438V4.25C16 3.65326 15.7629 3.08097 15.341 2.65901C14.919 2.23705 14.3467 2 13.75 2H10.75C10.1533 2 9.58097 2.23705 9.15901 2.65901C8.73705 3.08097 8.5 3.65326 8.5 4.25V5.05438C7.25133 5.23638 6.10973 5.86133 5.2836 6.81518C4.45746 7.76902 4.00188 8.98813 4 10.25V21.5C4 21.8978 4.15804 22.2794 4.43934 22.5607C4.72064 22.842 5.10218 23 5.5 23H19C19.3978 23 19.7794 22.842 20.0607 22.5607C20.342 22.2794 20.5 21.8978 20.5 21.5V10.25C20.4981 8.98813 20.0425 7.76902 19.2164 6.81518C18.3903 5.86133 17.2487 5.23638 16 5.05438ZM10.75 3.5H13.75C13.9489 3.5 14.1397 3.57902 14.2803 3.71967C14.421 3.86032 14.5 4.05109 14.5 4.25V5H10V4.25C10 4.05109 10.079 3.86032 10.2197 3.71967C10.3603 3.57902 10.5511 3.5 10.75 3.5ZM16 21.5H8.5C8.5 21.5 8.57902 21.5 8.71967 21.5C8.86032 21.5 9.05109 21.5 9.25 21.5H15.25C15.4489 21.5 15.6397 21.5 15.7803 21.5C15.921 21.5 16 21.5 16 21.5ZM8.5 21.5H13H14.5H16H8.5ZM19 21.5H17.5C17.5 21.5 17.2629 21.5 16.841 21.5C16.419 21.5 15.8467 21.5 15.25 21.5H12.25H9.25C8.65326 21.5 8.08097 21.5 7.65901 21.5C7.23705 21.5 7 21.5 7 21.5H5.5V10.25C5.5 9.25544 5.89509 8.30161 6.59835 7.59835C7.30161 6.89509 8.25544 6.5 9.25 6.5H15.25C16.2446 6.5 17.1984 6.89509 17.9017 7.59835C18.6049 8.30161 19 9.25544 19 10.25V21.5ZM14.5 9.5C14.5 9.69891 14.421 9.88968 14.2803 10.0303C14.1397 10.171 13.9489 10.25 13.75 10.25H10.75C10.5511 10.25 10.3603 10.171 10.2197 10.0303C10.079 9.88968 10 9.69891 10 9.5C10 9.30109 10.079 9.11032 10.2197 8.96967C10.3603 8.82902 10.5511 8.75 10.75 8.75H13.75C13.9489 8.75 14.1397 8.82902 14.2803 8.96967C14.421 9.11032 14.5 9.30109 14.5 9.5Z"
        fill="#262626"
        stroke="#262626"
        strokeWidth="0.2"
      />
    </SvgIcon>
  );
};

export default ColoredBackpackIcon;
